import * as React from "react";
import { useNavigate } from "react-router-dom";
import { profileLinks } from "~/modules/Profile";
import { useSession } from "~/modules/Profile/session";
import { useAbility } from "~/lib/ability";
import { RootAbility } from "~/root_ability";
import headerLogo from "~/assets/logo/mini-logo-b.svg";
import { UserMenu } from "./UserMenu";
import { NotificationsMenu } from "./NotificationsMenu";
import { getHeaderNotifications } from "./notifications";
import style from "./index.module.scss";

export const HeaderView = () => {
  let { session, signOut } = useSession();
  let navigate = useNavigate();
  const ability = useAbility(RootAbility);
  const notifications = React.useMemo(() => getHeaderNotifications(ability), [ability]);

  const headerLogoClassName = [style.headerContentLogo, STAGING && style.headerContentLogoStage]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={style.header}>
      {STAGING && <div className={style.stageTopBar} />}
      <div className={style.headerContent}>
        <div className={headerLogoClassName}>
          <img src={headerLogo} alt="BidMachine" />
        </div>

        <div className={style.headerContentControls}>
          <NotificationsMenu items={notifications} />
          <UserMenu
            userName={session.user.name}
            userEmail={session.user.email}
            userRole={session.user.role}
            onProfileClick={() => navigate(profileLinks.profile())}
            onSignOut={() => signOut?.()}
          />
        </div>
      </div>
    </div>
  );
};
